import { HStack, Stack, Text, Button, Box } from "@chakra-ui/react";
import React from "react";
import ReusableModal from "../../../components/ReusableModal";

export const PaymentModal = ({
  paymentModal,
  paymentData,
  verifyPayments,
  setPaymentModal,
}) => {
  const authUrl = paymentData?.makePayment?.data?.authorization_url;

  const openCheckout = () => {
    if (authUrl) window.location.href = authUrl;
  };

  return (
    <div>
      <ReusableModal
        isOpen={paymentModal}
        onClose={() => setPaymentModal(false)}
        title="Payment checkout"
        footer={
          <HStack alignItems={"center"} gap={"1em"}>
            <Button colorScheme="green" onClick={openCheckout}>
              Open Checkout (Paystack)
            </Button>
            <Button
              colorScheme="red"
              mr={3}
              onClick={() => setPaymentModal(false)}
            >
              Close
            </Button>
          </HStack>
        }
      >
        <Stack pb="4" pt="2" pl="2" fontWeight="500">
          <Text fontSize="1rem">Complete payment</Text>
          <HStack fontWeight={600} fontSize="12px"></HStack>
        </Stack>
        <Box mb="4">
          <Text fontSize="14px" fontWeight="semibold">
            Checkout URL
          </Text>
          <Text fontSize="12px" color="#666">
            The payment checkout will open in this tab.
          </Text>
        </Box>

        <Box mt="4">
          <Text fontSize="13px">Reference</Text>
          <Text fontWeight="semibold">
            {paymentData?.makePayment?.data?.reference}
          </Text>
        </Box>
      </ReusableModal>
    </div>
  );
};
